import { gql } from '@apollo/client';

const CHAT_MESSAGE_REFERENCE_DATA = `
  id
  jobId
  expertId
  projectId
  quote
  label
  sourceType
  expert {
    id
    fullName
    title
    country
    organization {
      name
      type
    }
  }
  project {
    id
    title
    team {
      id
      name
    }
  }
`;

const CHAT_MESSAGE_DATA = `
  id
  role
  text
  status
  error
  createdAt
  sentBy {
    id
    firstName
    lastName
    email
  }
  references {
    ${CHAT_MESSAGE_REFERENCE_DATA}
  }
`;

const CHAT_SESSION_SUMMARY_DATA = `
  id
  scopeType
  isOwner
  owner {
    id
    firstName
    lastName
    email
  }
  sharedWith {
    id
    email
  }
  title
  titleGenerated
  lastMessageAt
  messageCount
  createdAt
`;

export const PROJECT_CHAT_SESSIONS = gql`
  query ProjectChatSessions($projectId: ID!, $limit: Int, $offset: Int) {
    projectChatSessions(projectId: $projectId, limit: $limit, offset: $offset) {
      ${CHAT_SESSION_SUMMARY_DATA}
    }
  }
`;

export const TEAM_CHAT_SESSIONS = gql`
  query TeamChatSessions($teamId: ID!, $limit: Int, $offset: Int) {
    teamChatSessions(teamId: $teamId, limit: $limit, offset: $offset) {
      ${CHAT_SESSION_SUMMARY_DATA}
    }
  }
`;

export const GLOBAL_CHAT_SESSIONS = gql`
  query GlobalChatSessions($limit: Int, $offset: Int) {
    globalChatSessions(limit: $limit, offset: $offset) {
      ${CHAT_SESSION_SUMMARY_DATA}
    }
  }
`;

// Just enough to tell which mode (Team / Everything) and, for team sessions,
// which team a deep-linked /ai-chat/:sessionId belongs to.
export const CHAT_SESSION_SCOPE = gql`
  query ChatSessionScope($id: ID!) {
    chatSession(id: $id) {
      id
      scopeType
      team {
        id
        name
      }
    }
  }
`;

export const CHAT_SESSION = gql`
  query ChatSession($id: ID!, $messageLimit: Int) {
    chatSession(id: $id) {
      ${CHAT_SESSION_SUMMARY_DATA}
      messages(limit: $messageLimit) {
        ${CHAT_MESSAGE_DATA}
      }
    }
  }
`;

// Polled (see AiChat/index.jsx) while an assistant reply's status is
// 'pending' — deliberately fetches just this one message rather than the
// whole session, so polling stays cheap.
export const CHAT_MESSAGE = gql`
  query ChatMessage($id: ID!) {
    chatMessage(id: $id) {
      ${CHAT_MESSAGE_DATA}
    }
  }
`;

export const SEND_CHAT_MESSAGE = gql`
  mutation SendChatMessage($input: SendChatMessageInput!) {
    sendChatMessage(input: $input) {
      session {
        ${CHAT_SESSION_SUMMARY_DATA}
      }
      userMessage {
        ${CHAT_MESSAGE_DATA}
      }
      assistantMessage {
        ${CHAT_MESSAGE_DATA}
      }
    }
  }
`;

export const SHARE_CHAT_SESSION = gql`
  mutation ShareChatSession($sessionId: ID!, $userIds: [ID!]!) {
    shareChatSession(sessionId: $sessionId, userIds: $userIds) {
      ${CHAT_SESSION_SUMMARY_DATA}
    }
  }
`;
